import { defineComponent as n, openBlock as l, createBlock as c, unref as r, mergeProps as i, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconOfficial",
  __name: "IconOfficial",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (l(), c(r(f), i(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", { d: "M16.548 9.512a.75.75 0 1 0-1.096-1.024L10.4 13.901l-1.852-1.984a.75.75 0 0 0-1.096 1.023l2.034 2.18a1.25 1.25 0 0 0 1.828 0l5.234-5.608" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M13.764 3.401c-.993-1.535-3.24-1.535-4.233 0A1.02 1.02 0 0 1 8.306 3.8C6.6 3.141 4.782 4.462 4.88 6.288A1.02 1.02 0 0 1 4.124 7.33C2.357 7.8 1.662 9.937 2.816 11.356a1.02 1.02 0 0 1 0 1.288c-1.154 1.42-.46 3.556 1.308 4.026a1.02 1.02 0 0 1 .757 1.042C4.782 19.538 6.6 20.86 8.306 20.201a1.02 1.02 0 0 1 1.225.398c.993 1.535 3.24 1.535 4.233 0A1.02 1.02 0 0 1 14.99 20.2c1.706.658 3.523-.663 3.425-2.489a1.02 1.02 0 0 1 .757-1.042c1.767-.47 2.461-2.607 1.308-4.026a1.02 1.02 0 0 1 0-1.288c1.153-1.42.46-3.556-1.308-4.026a1.02 1.02 0 0 1-.757-1.042c.098-1.826-1.719-3.147-3.425-2.489A1.02 1.02 0 0 1 13.765 3.4M10.79 4.216a1.02 1.02 0 0 1 1.715 0A2.52 2.52 0 0 0 15.529 5.2a1.02 1.02 0 0 1 1.387 1.008 2.52 2.52 0 0 0 1.869 2.572 1.02 1.02 0 0 1 .53 1.631 2.52 2.52 0 0 0 0 3.18 1.02 1.02 0 0 1-.53 1.63 2.52 2.52 0 0 0-1.869 2.573 1.02 1.02 0 0 1-1.387 1.008 2.52 2.52 0 0 0-3.024.983 1.02 1.02 0 0 1-1.715 0A2.52 2.52 0 0 0 7.766 18.8a1.02 1.02 0 0 1-1.387-1.008 2.52 2.52 0 0 0-1.87-2.572 1.02 1.02 0 0 1-.53-1.631 2.52 2.52 0 0 0 0-3.18 1.02 1.02 0 0 1 .53-1.63 2.52 2.52 0 0 0 1.87-2.573 1.02 1.02 0 0 1 1.387-1.008 2.52 2.52 0 0 0 3.024-.983",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
